import React from 'react';
import FieldRadio from './fields/field_radio';
import FieldDate from './fields/field_date';
import SingleSelect from './fields/single_select';
import SingleSelectSearch from './fields/single_select_search';
import SingleSelectRemote from './fields/single_select_remote';
import FieldInt from './fields/field_int';
import FieldFloat from './fields/field_float';
import FieldText from './fields/field_text';
import FieldNestedMultipleEntities from './fields/field_nested_multiple_entities';
import FieldNestedOneOfEntities from './fields/field_nested_one_of_entities';
import FieldNestedSingleEntity from './fields/field_nested_single_entity';
import FieldMultipleFile from './fields/field_multiple_file';
import FieldStaticText from './fields/field_static_text';
import AutocompleteDadata from './fields/autocomplete_dadata';

class Field extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, scheme, defaultValue, refs, disabled, onChange, isLabel} = this.props;
        switch (scheme.type.format) {
            case 'radio':
                return (
                    <FieldRadio name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
            case 'date':
                return (
                    <FieldDate name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
            case 'single_select':
                const dataSource = scheme.type.data_source;
                if (dataSource === 'inner') {
                    return (
                        <SingleSelect name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}
                                      onChange={onChange} disabled={disabled} isLabel={isLabel}/>
                    );
                } else if (dataSource === 'remote_live_search') {
                    return (
                        <SingleSelectSearch name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                    );
                } else if (dataSource === 'remote_list') {
                    return (
                        <SingleSelectRemote name={name} scheme={scheme} defaultValue={defaultValue} refs={refs} isLabel={isLabel}/>
                    );
                } else {
                    return null;
                }
            case 'int':
                return (
                    <FieldInt name={name} scheme={scheme} defaultValue={defaultValue} refs={refs} isLabel={isLabel}/>
                );
            case 'float':
                return (
                    <FieldFloat name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
            case 'nested_multiple_entities':
                return (
                    <FieldNestedMultipleEntities name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
            case 'nested_one_of_entities':
                return (
                    <FieldNestedOneOfEntities name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
            case 'nested_single_entity':
                return (
                    <FieldNestedSingleEntity name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
            case 'file':
                return <FieldMultipleFile name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>;
            case 'static_text':
                return <FieldStaticText scheme={scheme}/>;
            case 'address':
                return <AutocompleteDadata name={name} scheme={scheme} defaultValue={defaultValue} refs={refs} />;
            case 'tiny_text':
            case 'middle_text':
            default:
                return (
                    <FieldText name={name} scheme={scheme} defaultValue={defaultValue} refs={refs}/>
                );
        }
    }
}

export default Field;